import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { TechRadarApi } from '@backstage-community/plugin-tech-radar';
import { TechRadarLoaderResponse } from '@backstage-community/plugin-tech-radar-common';
import { StackPoliciesClient } from './StackPoliciesClient';
import { buildRadarFromPolicies } from './buildRadarFromPolicies';

/**
 * Tech Radar API backed by Stack Policies (technologies + version policies).
 */
export class StackPoliciesTechRadarApi implements TechRadarApi {
  constructor(
    private readonly discoveryApi: DiscoveryApi,
    private readonly fetchApi: FetchApi,
  ) {}

  async load(_id: string | undefined): Promise<TechRadarLoaderResponse> {
    const client = new StackPoliciesClient(this.discoveryApi, this.fetchApi);
    const [technologies, policies] = await Promise.all([
      client.listTechnologies(),
      client.listPolicies(),
    ]);
    return buildRadarFromPolicies(technologies, policies);
  }
}
